import ApprovePoDialog from "./ApprovePoDialog";
import ConfirmVendorDialog from "./ConfirmVendorDialog";
import AddTrackingDialog from "./AddTrackingDialog";
import MarkDeliveredDialog from "./MarkDeliveredDialog";
import MarkReceivedDialog from "./MarkReceivedDialog";
import ResolvePoDialog from "./ResolvePoDialog";
import ApproveResolutionDialog from "./ApproveResolutionDialog";
import RequestApprovalDialog from "./RequestApprovalDialog";
import ResumeReceivingDialog from "./ResumeReceivingDialog";
import CreateBreakdownDialog from "./CreateBreakdownDialog";
import CalculateNetSalesDialog from "./CalculateNetSalesDialog";
import CreateSkusAndPoDialog from "./CreateSkusAndPoDialog";

const detailActionsComponentMap = {
    approve_po: ApprovePoDialog,
    confirm_vendor: ConfirmVendorDialog,
    add_tracking: AddTrackingDialog,
    add_delivery: MarkDeliveredDialog,
    mark_received: MarkReceivedDialog,
    resolve_po: ResolvePoDialog,
    resume_receiving: ResumeReceivingDialog,
    request_approval: RequestApprovalDialog,
    approve_resolution: ApproveResolutionDialog,
};

const dashboardActionsComponentMap = {
    create_breakdown: CreateBreakdownDialog,
    calculate_net_sales: CalculateNetSalesDialog,
    create_skus_and_po: CreateSkusAndPoDialog,
}

export default function PoDetailActionButton({
    po_doc_id, poName, addSnackbar, action, fetchPoDetails, delivDate,
    poType, currentPoId, upcGenerationAllowed, upcGenerationRequested,
    shippingFeeDefault = "", customsFeeDefault = "", otherFeeDefault = "",
}) {
    const DetailActionComponent = detailActionsComponentMap[action];
    const DashboardActionComponent = dashboardActionsComponentMap[action];

    return DetailActionComponent ? (
        <DetailActionComponent
            po_doc_id={po_doc_id}
            poName={poName}
            addSnackbar={addSnackbar}
            fetchPoDetails={fetchPoDetails}
            {...(delivDate && { delivDate })}
        />
    ) : DashboardActionComponent ? (
        <DashboardActionComponent
            po_doc_id={po_doc_id}
            poName={poName}
            addSnackbar={addSnackbar}
            fetchPoDetails={fetchPoDetails}
            isIcon={false}
            currentPoId={currentPoId}
            type={poType}
            upcGenerationAllowed={upcGenerationAllowed}
            upcGenerationRequested={upcGenerationRequested}
            shippingFeeDefault={shippingFeeDefault}
            customsFeeDefault={customsFeeDefault}
            otherFeeDefault={otherFeeDefault}
        />
    ) : null;
}